var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var Checkbox_1 = __importDefault(require("./Checkbox"));
exports.Checkbox = Checkbox_1.default;
exports.default = Checkbox_1.default;
//# sourceMappingURL=index.js.map